import { useI18n } from "vue-i18n";
import { DriverStatus } from "@/constants/user";

export function useUser() {
  const { t } = useI18n();

  const ownerStatusActive = "a";
  const ownerStatusNONOwner = "u";
  const ownerStatusOnHold = "h";

  const driverStatusActive = DriverStatus.Active;
  const driverStatusNotActive = DriverStatus.NotActive;
  const driverStatusOnHold = DriverStatus.OnHold;
  const driverStatusOnSilentHold = DriverStatus.OnSilentHold;

  const citizenships = [
    { id: "c", name: "Citizen" },
    { id: "g", name: "Green card" },
    { id: "e", name: "Employment Auth" },
    { id: "n", name: "Not legal" },
  ];

  const licenseTypes = [
    { id: "s", name: t("drivers.license-s") },
    { id: "c", name: t("drivers.license-c") },
  ];

  const driverCertificates = [
    { id: "hazmat", name: "Hazmat" },
    { id: "tsa", name: "TSA" },
    { id: "twic", name: "TWIC" },
    { id: "tanker_endorsement", name: "Tanker Endorsement" },
  ];

  const driverWillingsToCrossBorder = [
    { id: "c", name: "Canada" },
    { id: "m", name: "Mexico" },
  ];

  const driverStatuses = [
    { id: driverStatusActive, name: t("drivers.status-a") },
    { id: driverStatusNotActive, name: t("drivers.status-n") },
    { id: driverStatusOnHold, name: t("drivers.status-h") },
    { id: driverStatusOnSilentHold, name: t("drivers.status-s") },
  ];

  const ownerStatuses = [
    { id: "a", name: t("drivers.status-a") },
    { id: "n", name: t("drivers.status-n") },
    { id: "h", name: t("drivers.status-h") },
  ];

  const languages = [
    { id: "en", name: "English" },
    { id: "es", name: "Spanish" },
    { id: "uk", name: "Ukrainian" },
    { id: "ru", name: "Russian" },
  ];

  function getUserTypes(user: any, shortNames = false): string {
    if (!user) return "";
    const types = [];
    if (user.isOwner) types.push(shortNames ? "O" : t("drivers.owner"));
    if (user.isDriver) types.push(shortNames ? "D" : t("drivers.driver"));
    if (user.isCoordinator) types.push(shortNames ? "C" : t("drivers.coordinator"));
    return types.join("/");
  }

  return {
    ownerStatusActive,
    ownerStatusNONOwner,
    ownerStatusOnHold,
    driverStatusActive,
    driverStatusNotActive,
    driverStatusOnHold,
    driverStatusOnSilentHold,
    citizenships,
    licenseTypes,
    driverCertificates,
    driverWillingsToCrossBorder,
    driverStatuses,
    ownerStatuses,
    languages,
    getUserTypes,
  };
}
